module.exports = __webpack_public_path__ + "img/motorway_2x3_z16.54467943.svg";